var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#26B0EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3008,
    cy: 22.5,
    r: 8.5,
    fill: "#BEECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8008 45L38.5675 37.7667M42.4675 28.3333C42.4675 30.9704 41.6855 33.5483 40.2204 35.7409C38.7553 37.9336 36.6729 39.6426 34.2366 40.6517C31.8002 41.6609 29.1193 41.9249 26.5329 41.4105C23.9465 40.896 21.5707 39.6261 19.706 37.7614C17.8413 35.8967 16.5715 33.521 16.057 30.9345C15.5425 28.3481 15.8066 25.6672 16.8157 23.2309C17.8249 20.7945 19.5339 18.7122 21.7265 17.2471C23.9192 15.782 26.497 15 29.1341 15C32.6703 15 36.0617 16.4048 38.5622 18.9052C41.0627 21.4057 42.4675 24.7971 42.4675 28.3333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.f71f379a587f6323d7b0cbc13fff6962.svg";
export { ForwardRef as ReactComponent };